import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  FORMS_LIST,
  FORMS_RENDER,
  FORMS_SAVE,
  FORMS_PUBLISH,
  FORMS_UNPUBLISH,
  FORMS_DUPLICATE,
  FORMS_DELETE,
  FORMS_SUBMISSIONS,
  FORMS_SUBMISSION_DATA,
  // Task 24888 - the company's own form statuses.
  FORM_STATUS_LIST,
  FORM_STATUS_CREATE,
  FORM_STATUS_UPDATE,
  FORM_STATUS_DELETE,
  FORMS_SET_STATUS,
} from "./actionType";

import {
  formStatusListSuccess,
  formStatusListFailure,
  formStatusCreateSuccess,
  formStatusCreateFailure,
  formStatusUpdateSuccess,
  formStatusUpdateFailure,
  formStatusDeleteSuccess,
  formStatusDeleteFailure,
  setFormStatusSuccess,
  setFormStatusFailure,
  listFormsSuccess,
  listFormsFailure,
  renderFormSuccess,
  renderFormFailure,
  saveFormSuccess,
  saveFormFailure,
  publishFormSuccess,
  publishFormFailure,
  unpublishFormSuccess,
  unpublishFormFailure,
  duplicateFormSuccess,
  duplicateFormFailure,
  deleteFormsSuccess,
  deleteFormsFailure,
  listFormSubmissionsSuccess,
  listFormSubmissionsFailure,
  getFormSubmissionDataSuccess,
  getFormSubmissionDataFailure,
} from "./action";

import {
  listFormApi,
  renderFormApi,
  saveFormApi,
  publishFormApi,
  unpublishFormApi,
  formStatusListApi,
  formStatusCreateApi,
  formStatusUpdateApi,
  formStatusDeleteApi,
  setFormStatusApi,
  duplicateFormApi,
  deleteFormApi,
  listFormSubmissionsApi,
  getFormSubmissionDataApi,
} from "../../helpers/fakebackend_helper";

// List forms
function* listForms() {
  try {
    const response = yield call(listFormApi);
    yield put(listFormsSuccess(response));
  } catch (error) {
    yield put(listFormsFailure(error));
  }
}

function* listFormsWatcher() {
  yield takeEvery(FORMS_LIST, listForms);
}

// Render one form (full nested bundle)
function* renderForm({ payload }) {
  try {
    const response = yield call(renderFormApi, payload);
    yield put(renderFormSuccess(response));
  } catch (error) {
    yield put(renderFormFailure(error));
  }
}

function* renderFormWatcher() {
  yield takeEvery(FORMS_RENDER, renderForm);
}

// Save (create/update)
function* saveForm({ payload }) {
  try {
    const response = yield call(saveFormApi, payload);
    yield put(saveFormSuccess(response));
  } catch (error) {
    yield put(saveFormFailure(error));
  }
}

function* saveFormWatcher() {
  yield takeEvery(FORMS_SAVE, saveForm);
}

// Publish
function* publishForm({ payload }) {
  try {
    const response = yield call(publishFormApi, payload);
    yield put(publishFormSuccess(response));
  } catch (error) {
    yield put(publishFormFailure(error));
  }
}

function* publishFormWatcher() {
  yield takeEvery(FORMS_PUBLISH, publishForm);
}

// Unpublish
function* unpublishForm({ payload }) {
  try {
    const response = yield call(unpublishFormApi, payload);
    yield put(unpublishFormSuccess(response));
  } catch (error) {
    yield put(unpublishFormFailure(error));
  }
}

function* unpublishFormWatcher() {
  yield takeEvery(FORMS_UNPUBLISH, unpublishForm);
}

// Duplicate
function* duplicateForm({ payload }) {
  try {
    const response = yield call(duplicateFormApi, payload);
    yield put(duplicateFormSuccess(response));
  } catch (error) {
    yield put(duplicateFormFailure(error));
  }
}

function* duplicateFormWatcher() {
  yield takeEvery(FORMS_DUPLICATE, duplicateForm);
}

// Delete
function* deleteForms({ payload }) {
  try {
    const response = yield call(deleteFormApi, payload);
    yield put(deleteFormsSuccess(response));
  } catch (error) {
    yield put(deleteFormsFailure(error));
  }
}

function* deleteFormsWatcher() {
  yield takeEvery(FORMS_DELETE, deleteForms);
}

// Submissions list for a form
function* listFormSubmissions({ payload }) {
  try {
    const response = yield call(listFormSubmissionsApi, payload);
    yield put(listFormSubmissionsSuccess(response));
  } catch (error) {
    yield put(listFormSubmissionsFailure(error));
  }
}

function* listFormSubmissionsWatcher() {
  yield takeEvery(FORMS_SUBMISSIONS, listFormSubmissions);
}

// Single submission (values + files)
function* getFormSubmissionData({ payload }) {
  try {
    const response = yield call(getFormSubmissionDataApi, payload);
    yield put(getFormSubmissionDataSuccess(response));
  } catch (error) {
    yield put(getFormSubmissionDataFailure(error));
  }
}

function* getFormSubmissionDataWatcher() {
  yield takeEvery(FORMS_SUBMISSION_DATA, getFormSubmissionData);
}


function* formStatusListSaga({ payload }) {
  try {
    const response = yield call(formStatusListApi, payload);
    yield put(formStatusListSuccess(response));
  } catch (error) {
    yield put(formStatusListFailure(error));
  }
}

function* formStatusListWatcher() {
  yield takeEvery(FORM_STATUS_LIST, formStatusListSaga);
}

function* formStatusCreateSaga({ payload }) {
  try {
    const response = yield call(formStatusCreateApi, payload);
    yield put(formStatusCreateSuccess(response));
  } catch (error) {
    yield put(formStatusCreateFailure(error));
  }
}

function* formStatusCreateWatcher() {
  yield takeEvery(FORM_STATUS_CREATE, formStatusCreateSaga);
}

function* formStatusUpdateSaga({ payload }) {
  try {
    const response = yield call(formStatusUpdateApi, payload);
    yield put(formStatusUpdateSuccess(response));
  } catch (error) {
    yield put(formStatusUpdateFailure(error));
  }
}

function* formStatusUpdateWatcher() {
  yield takeEvery(FORM_STATUS_UPDATE, formStatusUpdateSaga);
}

function* formStatusDeleteSaga({ payload }) {
  try {
    const response = yield call(formStatusDeleteApi, payload);
    yield put(formStatusDeleteSuccess(response));
  } catch (error) {
    yield put(formStatusDeleteFailure(error));
  }
}

function* formStatusDeleteWatcher() {
  yield takeEvery(FORM_STATUS_DELETE, formStatusDeleteSaga);
}

function* setFormStatusSaga({ payload }) {
  try {
    const response = yield call(setFormStatusApi, payload);
    yield put(setFormStatusSuccess(response));
  } catch (error) {
    yield put(setFormStatusFailure(error));
  }
}

function* setFormStatusWatcher() {
  yield takeEvery(FORMS_SET_STATUS, setFormStatusSaga);
}

export default function* Forms() {
  yield all([
    fork(listFormsWatcher),
    fork(renderFormWatcher),
    fork(saveFormWatcher),
    fork(publishFormWatcher),
    fork(unpublishFormWatcher),
    fork(duplicateFormWatcher),
    fork(deleteFormsWatcher),
    fork(listFormSubmissionsWatcher),
    fork(getFormSubmissionDataWatcher),
    fork(formStatusListWatcher),
    fork(formStatusCreateWatcher),
    fork(formStatusUpdateWatcher),
    fork(formStatusDeleteWatcher),
    fork(setFormStatusWatcher),
  ]);
}
